module.exports = __webpack_public_path__ + "assetsclientes/img/card-basic-mobile.1aba2cea.png";